<template>
  <TableTemplate
    v-model="tableResult"

    :columns="websiteColumns"
    :columnVariables="websiteColumnVariables"
    :capitalize="capitalize"
    :skeletonClass="skeletonClass"

    :page="page"
    :enable-sorting="true"

    @update-column-order="updateColumnOrder"
    @set-page="v => page = v"
    :on-row-click="handleClickRow"
    
    :max="max"

    ref="table"
  >
    <template #cell-status="{value}">
      <span class="tag mb-1 d-inline-block" :style="supplierOrderStatus[value].color">
          {{ supplierOrderStatus[value].str }}
        </span>
      <!-- <span class="p12" :class="supplierOrderStatus[value].color">{{ supplierOrderStatus[value].value }}</span> -->
    </template>
    <template #above>
      <TableHeader
        title="Supplier orders"
        :alwaysShowMultiSelectCheckbox="true"
        :removeColumnConfiguration="true"
        :refetch="refetch"
        :exportParams="exportEndpointParams"

        @customize-layout="customizeLayout"
      >
        <template #header-buttons-before="props">
          <slot name="header-buttons-before" v-bind="props"></slot>
        </template>
      </TableHeader>

      <div class="d-flex">
        <TableMainSearchField v-model="search"/>
        <RefreshBtn
          :loading="isLoadingTableResult"
          @click.native="refresh"
        />
      </div>
    </template>

    <template #empty-state>
      <EmptyStatePlaceholder
        title="Er zijn geen leveranciers"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
        </svg>
      </EmptyStatePlaceholder>
    </template>
  </TableTemplate>
</template>

<script>

import TableTemplate from 'src/layout/Table/TableTemplate'
import tableFieldOptions from "src/mixins/tableFieldOptions"
import TableSearchField from "src/components/Inputs/TableSearchField.vue"
import TableActionDropdown from "src/components/Inputs/TableActionDropdown.vue"
import EmptyStatePlaceholder from "src/layout/EmptyStatePlaceholder.vue"
import HeaderButton from "src/components/Inputs/HeaderButton.vue"
import TableHeader from "src/components/Product/ProductTable/TableHeader.vue"
import TableMainSearchField from '../layout/TableMainSearchField.vue'
import RefreshBtn from '../layout/RefreshBtn.vue'

import TableCell from "src/components/Table/TableCell.vue"

import table from "src/mixins/table"
import { SUPPLIER_ORDER_STATUS } from "@/utils/product";

export default {
  metaInfo: {
    title: "Supplier Order",
  },
  components: {
    TableCell,
    TableMainSearchField,
    TableTemplate,
    TableSearchField,
    RefreshBtn,
    TableActionDropdown,
    TableHeader,
    EmptyStatePlaceholder,
    HeaderButton,
  },
  mixins: [
    tableFieldOptions,
    table({
      pageReference: 'suppliers',
      
      params: {
        sku: null,
        price: 0,
        website: "",
        search: "",
      },
      route: "/api/supplier_orders",
    }),
  ],
  data() {
    return {
      supplierOrderStatus: SUPPLIER_ORDER_STATUS
    }
  },

  methods: {
    handleClickRow(item) {
      this.$router.push(`/admin/supplier-orders/${item.uid}`)
    },
  },
  computed: {
    table() {
      return this.$refs.table
    },
    websiteColumns() {
      return ['Title', 'Supplier', 'Status', 'Updated At']
    },
    websiteColumnVariables() {
      return ['title','supplier', 'status', 'updatedAt']
    },
    capitalize() {
      return [false]
    },
  }
}
</script>

<style>
.tag {
  font-size: 10px !important;
  border-radius: 10px;
  padding: 1px 5px;
  color: white;
  font-weight: 600;
}

.tag + .tag {
  margin-left: 4px;
}
</style>
